export enum LocalStorage {
  Backlink = 'backlink',
  DEV_CONFIG = 'ffg_dev_config'
}
